import { render } from "./CarouselList.vue?vue&type=template&id=0ca49bef&scoped=true"
import script from "./CarouselList.vue?vue&type=script&lang=js"
export * from "./CarouselList.vue?vue&type=script&lang=js"

import "./CarouselList.vue?vue&type=style&index=0&id=0ca49bef&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca49bef"]])

export default __exports__